module.exports = __webpack_public_path__ + "static/img/index3(1)_13.3d22ee5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index3(1)_13.png
// module id = 3129
// module chunks = 1